import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaSpinner } from 'react-icons/fa'; // Import spinner icon
import authimage from "../../public/auth-image.jpg";

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true when the request starts
    setError(null);   // Reset any previous errors

    try {
      const response = await axios.post(
        'https://citi-mobile-app.onrender.com/api/auth/admin/login',
        //  "http://localhost:3005/api/auth/admin/login",
         formData);
      const { token, role, user } = response.data;

      // Store the user details and token
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));  // Correctly store user object
      
      alert('Login successful!');

      // Navigate based on the role
      if (role === 'fieldsalesagents') {
        navigate('/SalesAgentDashboard');
      } else if (role === 'admin') {
        navigate('/adminDashboard');
      } else if (role === 'salessupervisors') {
        navigate('/SalesAgentPerformance');
      } else if (role === 'businessmanager') {
        navigate('/BusinessDashboardCards');
      }
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false); // Set loading state to false when the request completes
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 max-sm:bg-white max-sm:w-full">
      <div className="flex bg-white shadow-lg max-sm:shadow-none max-sm:w-full rounded-lg overflow-hidden">
        <div className="w-1/2 p-8 max-sm:w-full ">
          <h2 className="text-2xl font-bold mb-6 text-gray-700">Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-600 text-sm font-semibold mb-2" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email"
                className="border w-full p-3 rounded-lg focus:outline-none focus:ring focus:border-blue-500"
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-600 text-sm font-semibold mb-2" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                className="border w-full p-3 rounded-lg focus:outline-none focus:ring focus:border-blue-500"
              />
            </div>

            <div className="text-right mb-4">
              <a href="#" className="text-blue-500 text-sm hover:underline">Forgot Password?</a>
            </div>

            {/* Button with spinner */}
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition duration-300 flex justify-center items-center"
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <>
                  <FaSpinner className="animate-spin mr-2" /> {/* Spinner icon */}
                  Logging in...
                </>
              ) : (
                'Login'
              )}
            </button>

            {error && <p className="text-red-500 mt-4">{error}</p>}
          </form>
        </div>

        <div className="w-1/2 max-sm:hidden">
          <img src={authimage} alt="Auth" className="object-cover h-full w-full" />
        </div>
      </div>
    </div>
  );
};

export default Login;
